import { render } from "./CardN2f.vue?vue&type=template&id=275553ee"
import script from "./CardN2f.vue?vue&type=script&lang=ts"
export * from "./CardN2f.vue?vue&type=script&lang=ts"
script.render = render

export default script